import SuggestedActions from './SuggestedActions.component';

export default SuggestedActions;